import { Button, Card } from '@folio/stripes/components';
import React from 'react';
import { FieldArray } from 'react-final-form-arrays';
import { FormattedMessage } from 'react-intl';
import { CriteriaTerminalType } from '../../types';
import ConditionalCard from '../ConditionalCard';
import TransferAccountFields from '../TransferAccountFields';
import css from './TransferInfoSection.module.css';
export default function TransferInfoSection() {
    return (React.createElement(FieldArray, { name: "transferInfo.conditions" }, function (_a) {
        var fields = _a.fields;
        return (React.createElement(React.Fragment, null,
            fields.map(function (name, index) { return (React.createElement(ConditionalCard, { key: name, index: index, fieldArrayName: "transferInfo.conditions", conditionName: "".concat(name, ".condition") },
                React.createElement(TransferAccountFields, { prefix: "".concat(name, ".") }))); }),
            React.createElement(Card, { headerStart: fields.length ? (React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.otherwise" })) : (React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.transfer.transferTo" })) },
                React.createElement(TransferAccountFields, { prefix: "transferInfo.else." })),
            React.createElement(Button, { onClick: function () { return fields.push({
                    condition: { type: CriteriaTerminalType.PATRON_GROUP },
                }); } },
                React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.button.addCondition" })),
            !!fields.length && (React.createElement("p", { className: css.evaluationDescription },
                React.createElement("i", null,
                    React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.transfer.description" }))))));
    }));
}
